const storage = {
  version: '--version',
};

export default storage;
